import { render } from "./WhatsAppSignup.vue?vue&type=template&id=60ec9aaa&scoped=true"
import script from "./WhatsAppSignup.vue?vue&type=script&lang=js"
export * from "./WhatsAppSignup.vue?vue&type=script&lang=js"

import "./WhatsAppSignup.vue?vue&type=style&index=0&id=60ec9aaa&scoped=true&lang=css"

import exportComponent from "../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ec9aaa"]])

export default __exports__